import { useSelector } from 'react-redux';
import { buildFcmRequestItem, postFcmServer } from '../Services/Common/fcmApi';

const DEFAULT_CHUNK_SIZE = 100;

/**
 * FCM 발송 훅
 * @returns {Function} sendFcm — 단일 수신자 (기존 호환)
 * @returns {Function} sendFcm.bulk — 다수 수신자 PostFcmServer 배열 발송
 */
const useFcmHandler = () => {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const requestUserId = userInfo?.userid ?? '';

  const sendFcmBulk = async ({
    targetUserIds,
    title,
    body,
    codeGroup,
    route,
    responseData,
    deviceTypes,
    chunkSize = DEFAULT_CHUNK_SIZE,
  }) => {
    const ids = (targetUserIds || []).filter(Boolean);
    if (!ids.length) return;

    const size = Math.max(1, chunkSize);
    for (let i = 0; i < ids.length; i += size) {
      const chunk = ids.slice(i, i + size);
      const payload = chunk.map((targetUserId) =>
        buildFcmRequestItem(
          {
            targetUserId,
            title,
            body,
            codeGroup,
            route,
            responseData,
            deviceTypes,
          },
          requestUserId
        )
      );
      try {
        await postFcmServer(payload);
        console.log(
          `✅ FCM bulk 발송: ${chunk.length}명 (${Math.min(i + chunk.length, ids.length)}/${ids.length})`
        );
      } catch (error) {
        console.error('❌ sendFcmBulk chunk error:', error);
      }
    }
  };

  const sendFcm = async ({
    targetUserId,
    body,
    codeGroup,
    title,
    route,
    responseData,
    deviceTypes,
  }) => {
    if (!targetUserId) return;
    try {
      await sendFcmBulk({
        targetUserIds: [targetUserId],
        title,
        body,
        codeGroup,
        route,
        responseData,
        deviceTypes,
        chunkSize: 1,
      });
    } catch (error) {
      console.error('❌ sendFcm error:', error);
    }
  };

  sendFcm.bulk = sendFcmBulk;
  return sendFcm;
};

export default useFcmHandler;
